import VectorTileLayer from "ol/layer/VectorTile";
import VectorTileSource from 'ol/source/VectorTile';
import MVT from 'ol/format/MVT';
import { Style, Fill, Stroke} from 'ol/style';

/**
 * The default style.
 */
export const wertvolleLandwBoedenLayerStyle = new Style({
  stroke: new Stroke({
    color: 'rgba(102,0,51,1)',
    width: 3
  }),
  fill: new Fill({
    color: 'rgba(102,51,153,0.5)'
  })
});
  

const beatLayers = ['beat'/*,'beatp'*/];

const url = "https://wasser.umweltbundesamt.at/vt/beat/{z}/{x}/{y}.pbf";

export const wertvolleLandwBoedenLayer = new VectorTileLayer({
  source: new VectorTileSource({
    format: new MVT({ layers: beatLayers }),
    url: url,
    minZoom: 6, // needed in order to enable overzoom
    maxZoom: 15, // needed in order to enable overzoom
  }),
  minZoom:6, 
  maxZoom:22,
  style: wertvolleLandwBoedenLayerStyle,
  visible: true
});